
export default function AuthorizationList() {

  function ItemList(props) {
    return <li>{ props.paragraph }</li>;
  }

  const list = [
    'Enviar comunicaciones por correo físico, electrónico, redes sociales, dispositivo móvil, o cualquier otro medio análogo y/o digital con información cultural, comercial, publicitaria o promocional sobre los productos, servicios, eventos, promociones y/o campañas adelantadas por EL PRESTADOR, o información que podría resultar de interés para EL AFILIADO, e información relacionada con la relación contractual o comercial existente entre EL PRESTADOR y EL AFILIADO.',
    'Prestación efectiva de los servicios del PRESTADOR.',
    'Como herramienta para el inicio de cualquier cobro prejudicial o judicial.',
    'Enviar invitaciones a eventos.',
    'Realizar encuestas y solicitar la opinión de  EL AFILIADO sobre los servicios.',
    'Realizar pauta en relación con las preferencias y gustos del AFILIADO.',
    'Adelantar investigaciones de mercado, comerciales y/o estadísticas, identificar las tendencias del mercado, obtener perfiles demográficos, redes sociales y demás sitios de los clientes potenciales o efectivos.',
    'Construir perfiles según los hábitos y preferencias del AFILIADO, que le permitan al PRESTADOR ofrecerle productos y/o servicios de su posible interés, así como desarrollar nuevos productos y/o servicios, o estrategias, dirigidas a impactar a otros AFILIADOS.',
    'Como elemento de análisis para establecer y mantener una relación contractual o comercial, cualquiera que sea su naturaleza.',
    'Realizar seguimiento de actividades promocionales.',
    'Atender solicitudes, quejas, peticiones y reclamos.',
    'Permitir el ejercicio de los derechos de los consumidores y de los Titulares de los Datos Personales.',
    'Ofrecer servicios complementarios de salud.',
    'Informar sobre cambios de precios y servicios.',
    'Informar directamente sobre alianzas y promociones de terceros.',
    'Evaluar la calidad de los servicios del  PRESTADOR',
    'Transferir los datos personales de EL AFILIADO a las compañías vinculadas en Colombia y en el exterior del PRESTADOR, cuando sea necesario para la prestación de servicios a favor del Titular.'
  ];

  return (
    <>
	    <ul>
        {list.map((item) => <ItemList paragraph={item} />)}
      </ul>
    </>
  );

}
